import { Alert, AlertDescription, AlertTitle, cn } from "@qw/ui";

import { useChat } from "../providers/chat-provider";
import { ChatArtifactDrawer } from "./chat-artifact-drawer";
import { ChatForm } from "./chat-form/chat-form";
import { ChatScrollToBottom } from "./chat-scroll-to-bottom";

export type ChatFooterVariant = "default" | "chromeless";

interface ChatFooterProps {
  variant?: ChatFooterVariant;
}

export const ChatFooter = ({ variant = "default" }: ChatFooterProps) => {
  const { footerRef, isReadOnly, shouldAutoScroll } = useChat();

  return (
    <div ref={footerRef} className={cn(variant === "chromeless" ? "flex-none" : "sticky bottom-0 border-t bg-inherit")}>
      {!shouldAutoScroll && <ChatScrollToBottom />}

      {variant === "default" ? <ChatArtifactDrawer /> : null}

      <div className="p-2 2xl:p-3">
        {isReadOnly ? (
          <Alert variant="default" icon="visibility_lock">
            <AlertTitle className="text-sm">This chat is read-only.</AlertTitle>
            <AlertDescription>
              <p>Only the session owner can send messages or respond to requests here.</p>
            </AlertDescription>
          </Alert>
        ) : (
          <ChatForm />
        )}
      </div>
    </div>
  );
};
